<template>
  <div id="ravenwareSite" ref="ravenwareSite">

    <div id="site-header">
      <div class="row">
        <div class="col-md-3" id="site-logo-wrap">
          <a href="/"><img src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo" id="site-logo"></a>
          <p id="associated">Part of <a href="https://ukitnetworks.com/" target="_blank"><img src="resources/images/logos/uk_it_networks_x100.png" alt="UK IT Networks" id="associated-logo"></a></p>
        </div>
        <div class="col-md-9 menu-items">
          <div class="items">
            <a href="/home">Business Broadband</a>
            <a href="/ethernet">Leased Line</a>
            <a href="/about-us">About Us</a>
            <a href="/support">Help and Support</a>
            <a href="/partners">Partners</a>
          </div>
          <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
        </div>
      </div>
    </div>

    <div id="background-outer" style="background-image:url('resources/images/ukit_networks_business_broadband.png');">
      <div id="background-inner">

        <div id="site-hero">
          <h1>Business <br>Broadband Deals</h1>
          <h2>Compare the latest <span>high speed</span> Broadband<br>deals available to UK businesses</h2>
          <h3>Enter Your Details To Get Started</h3>
        </div>

        <div id="greenFrame" ref="greenFrame" style="background:#fff;">
          <div v-if="isLoading && stage !== 'fetchingDeals'" id="loading" style="width:100%; height:100%; z-index:2000; position:absolute; top:0px; left:0px; padding:50px;">
            <loading :active.sync="isLoading" :can-cancel="false" :color="'#666'" :is-full-page="false"></loading>
          </div>
          <div v-if="isLoading && stage === 'fetchingDeals'" class="col-md-12 resultRow" id="stillLoading">
            <div class="resHeader text-center">
              <div class="wrap">
                <div class="track">
                  <div class="pacman"></div>
                  <div class="dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
              <!-- <p class="saving"><span>Checking with all network partners</span><span>.</span><span>.</span><span>.</span><span>.</span><span>.</span></p> -->
              <div style="width:100%; background-color:rgba(249, 249, 249, 0.2); padding:5px; margin-bottom:15px; margin-top:-10px;">
                <i class="fa fa-info-circle" style="padding-right:6px;"></i><strong>It may take up to 90 seconds to return all pricing results</strong>
              </div>
            </div>
          </div>
          <div class="text-center pt-4" v-if="!params.tid">
            <p>No TID provided</p>
          </div>
          <div v-if="params.tid">
            <div class="wizardski">
              <div id="thankyou" class="text-center" v-if="stage === 'thankyou'">
                <div class="row">
                  <div class="col-md-10 offset-md-1">
                    <h4>Thank you for placing your business with UK IT Networks Limited for {{ order.selectedQuote.productName }}.</h4>
                    <p>An email has been sent to {{ order.emailAddress }} to confirm your order.</p>
                    <p>Your order for services will be reviewed for acceptance and then processed within the next business day. Once validated we will confirm that we have accepted your order. Any questions please dont hesitate to call us on: <a href="callto:03443262154" class="text-ukit-primary">0344 326 2154</a></p>
                  </div>
                </div>
                <div class="row">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Your Product</th>
                        <th class="text-center">Download Speeds</th>
                        <th class="text-center">Upload Speeds</th>
                        <th class="text-center">Minimum Speed</th>
                        <th>Price</th>
                        <th class="text-center">Lead Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="productTblName text-ukit-secondary">
                          <span>
                            {{ order.selectedQuote.productName }}
                          </span>
                        </td>
                        <td style="font-size:small; padding:5px;" class="text-center">
                          <strong class="mbl">Download Speeds: </strong>
                          <span v-if="order.selectedQuote.productSpeed.estimatedDownloadRange.includes('-')">
                            {{ formatHyphenatedToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }}
                          </span>
                          <span v-if="!order.selectedQuote.productSpeed.estimatedDownloadRange.includes('-')">
                            {{ formatToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }}
                          </span>
                        </td>
                        <td style="font-size:small; padding:5px;" class="text-center">
                          <strong class="mbl">Upload Speeds: </strong>
                          <span v-if="order.selectedQuote.productSpeed.estimatedUploadRange.includes('-')">
                            {{ formatHyphenatedToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }}
                          </span>
                          <span v-if="!order.selectedQuote.productSpeed.estimatedUploadRange.includes('-')">
                            {{ formatToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }}
                          </span>
                        </td>
                        <td style="font-size:small;" class="text-center text-ukit-primary">
                          <strong class="mbl">Mimimum Speed: </strong>
                          {{ formatToMbps(order.selectedQuote.productSpeed.minimumGuaranteedSpeed) }}
                        </td>
                        <td style="padding:5px;">
                          <div>
                            <!-- test   toTwoDecimalPlaces(order.totalMonthlyCost) -->
                            <span v-if="order.termLength === '12 Months'">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband12monthMonthlyRental) }}<span style="font-size:small;">/Month</span></span>
                            <span v-if="order.termLength === '36 Months'">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband36monthMonthlyRental) }}<span style="font-size:small;">/Month</span></span>
                          </div>
                          <div style="font-size:small;">
                            <span v-if="order.orderType !== 'Existing Line' && order.termLength === '12 Months'">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband12MonthConnectionCost) }} connection</span>
                            <span v-if="order.orderType !== 'Existing Line' && order.termLength === '36 Months'">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband36MonthConnectionCost) }} connection</span>
                            <span v-if="order.orderType === 'Existing Line'">£{{ toTwoDecimalPlaces(order.pricing.migrationSellRate) }} migration</span>
                          </div>
                        </td>
                        <td style="font-size:small; padding:5px;" class="text-center">
                          <strong class="mbl">Lead Time: </strong>
                          <span>{{ order.selectedQuote.leadTime | moment("calendar") }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div id="wizardski" class="" v-if="stage == 'order'">
                <div class="row">
                  <div class="col-md-8">
                    <v-stepper v-model="currentStep">
                      <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1"><span class="ml-2">Your Details</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 2" step="2"><span class="ml-2">Installation</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 3" step="3"><span class="ml-2">Broadband Options</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="4"><span class="ml-2">Confirm Order</span></v-stepper-step>
                      </v-stepper-header>
                      <v-stepper-items>
                        <v-stepper-content step="1">
                          <div>
                            <v-form ref="detailsForm" lazy-validation v-model="detailsFormValid" class="bbc_zeroTop">
                              <v-container class="bbc_zeroTop">
                                <v-row class="bbc_zeroTop">
                                  <v-col class="bbc_zeroTop" cols="12" md="12">
                                    <div>
                                      <div class="mr-4" style="float:left;">
                                        <h4 v-bind:class="{'text-muted': !order.existingCustomer}">Existing Customer</h4>
                                      </div>
                                      <div>
                                        <a-switch style="margin-top: 20px;" size="small" @change="toggleExistingCustomer()" />
                                      </div>
                                    </div>
                                    <br>
                                    <div v-if="order.existingCustomer === true">
                                      <div class="left-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactFirstName" v-model="order.authorisedContactFirstName" label="First Name"></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactLastName" v-model="order.authorisedContactLastName" label="Last Name" ></v-text-field>
                                      </div>
                                      <div class="left-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="emailAddress" v-model="order.emailAddress" label="Email Address" ></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="crmAccountNumber" v-model="order.crmAccountNumber" label="Existing Customer Account Number" ></v-text-field>
                                      </div>
                                      <div class="left-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="companyName" v-model="order.companyName" label="Company Name" ></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field filled dense ref="accountSite" v-model="order.accountSite" label="Account Site e.g Head Office" ></v-text-field>
                                      </div>
                                    </div>
                                    <div v-if="order.existingCustomer === false">
                                      <h4 v-bind:class="{'text-muted': order.existingCustomer}">New Customer</h4>
                                      <div class="left-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactFirstName" v-model="order.authorisedContactFirstName" label="First Name" ></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactLastName" v-model="order.authorisedContactLastName" label="Last Name" ></v-text-field>
                                      </div>
                                      <v-text-field required :rules="requiredRules" filled dense ref="emailAddress" v-model="order.emailAddress" label="Email Address" ></v-text-field>
                                      <hr>
                                      <div class="left-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="companyName" v-model="order.companyName" label="Company Name" ></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field filled dense ref="accountSite" v-model="order.accountSite" label="Account Site e.g Head Office" ></v-text-field>
                                      </div>
                                      <div class="left-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="phoneNumber" v-model="order.phoneNumber" label="Phone Number" ></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field filled dense ref="faxNumber" v-model="order.faxNumber" label="Fax Number (Optional)" ></v-text-field>
                                      </div>
                                      <div class="left-field">
                                        <v-text-field filled dense ref="website" v-model="order.website" label="Website" ></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="numberOfEmployees" v-model="order.numberOfEmployees" label="Number Of Employees" ></v-text-field>
                                      </div>
                                      <v-text-field filled dense ref="registeredNumber" v-model="order.registeredNumber" label="Registered Number (If not registered, state business type)" ></v-text-field>
                                      <h4>Billing Contact</h4>
                                      <div class="left-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="accountsContactFirstName" v-model="order.accountsContactFirstName" label="First Name"></v-text-field>
                                      </div>
                                      <div class="right-field">
                                        <v-text-field required :rules="requiredRules" filled dense ref="accountsContactLastName" v-model="order.accountsContactLastName" label="Last Name"></v-text-field>
                                      </div>
                                      <v-text-field required :rules="requiredRules" filled dense ref="accountsContactEmail" v-model="order.accountsContactEmail" label="Email Address" ></v-text-field>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </div>
                          <div style="margin-top:-30px; margin-right:12px;" class="float-right">
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="backToBroadbandSelect()">Back</v-btn>
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="goToInstall()">Next</v-btn>
                          </div>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                          <div>
                            <h4>Installation Details</h4>
                            <p>To get you set up, we just need a few key details about your business. Please complete the fields below.</p>
                            <v-form ref="installForm" lazy-validation v-model="orderFormValid" class="bbc_zeroTop">
                              <v-container class="bbc_zeroTop">
                                <v-row class="bbc_zeroTop">
                                  <v-col class="bbc_zeroTop" cols="12" md="12">
                                    <h5>Address Details</h5>
                                    <v-text-field v-on:keyup="addressChange()" required :rules="requiredRules" filled dense ref="installAddress" v-model="order.addresses[0].address" label="Address" ></v-text-field>
                                    <v-text-field v-on:keyup="addressChange()" filled dense ref="installStreet" v-model="order.addresses[0].street" label="Street" ></v-text-field>
                                    <v-text-field v-on:keyup="addressChange()" required :rules="requiredRules" filled dense ref="installCounty" v-model="order.addresses[0].county" label="County" ></v-text-field>
                                    <!-- <v-text-field v-on:keyup="addressChange()" dense ref="installCountry" v-model="order.addresses[0].country" label="Country" ></v-text-field> -->
                                    <v-text-field v-on:keyup="addressChange()" required :rules="requiredRules" filled dense ref="installPostcode" v-model="order.addresses[0].postcode" label="Post Code" ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </div>
                          <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="previousStep()">Back</v-btn>
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="goToOrder()">Next</v-btn>
                          </div>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                          <v-form lazy-validation ref="installForm" v-model="installFormValid" class="bbc_zeroTop">
                            <v-container class="bbc_zeroTop">
                              <v-row class="bbc_zeroTop">
                                <v-col class="bbc_zeroTop" cols="12" md="12">

                                  <div v-if="!order.selectedQuote.productName.includes('SOGEA')">
                                    <h5>Business Line</h5>
                                    <v-row>
                                      <v-col cols="12">
                                        <a-select :disabled="true" size="large" default-value="New Line" @change="lineTypeChange" v-model="order.orderType">
                                          <a-select-option value="Existing Line">Existing Business Line</a-select-option>
                                          <a-select-option value="New Line">New Business Line</a-select-option>
                                        </a-select>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <h5>Contract Term</h5>
                                  <v-row>
                                    <v-col cols="12">
                                      <a-select @change="termChanged()" size="large" default-value="36 Months" v-model="order.termLength">
                                        <a-select-option value="12 Months">12 Months</a-select-option>
                                        <a-select-option value="36 Months">36 Months</a-select-option>
                                      </a-select>
                                    </v-col>
                                  </v-row>

                                  <h5>Router</h5>
                                  <v-row>
                                    <v-col cols="12">
                                      <a-select @change="routerChanged" size="large" default-value="Technicolor Wireless"  v-model="order.router">
                                        <a-select-option value="No Router Required">No Router Required £0.00</a-select-option>
                                        <a-select-option value="Technicolor Wireless">
                                          <span v-if="order.termLength === '12 Months'">Technicolor Pre-Configured Wireless Router inc. Delivery &amp; Configuration £6.95 per month</span>
                                          <span v-if="order.termLength === '36 Months'">Technicolor Pre-Configured Wireless Router inc. Delivery &amp; Configuration £2.35 per month</span>
                                        </a-select-option>
                                      </a-select>
                                    </v-col>
                                  </v-row>

                                  <h5>Tariff</h5>
                                  <div id="generic_price_table">
                                    <section>
                                      <div class="container">
                                        <div class="row">
                                          <div class="col-lg-4">
                                            <div v-bind:class="{active : order.callOption === 'PAYG Calls' }" class="generic_content clearfix">
                                              <div class="generic_head_price clearfix">
                                                <div class="generic_head_content clearfix">
                                                  <div class="head_bg"></div>
                                                  <div class="head">
                                                    <span>PAYG Calls</span>
                                                  </div>
                                                </div>
                                                <div class="generic_price_tag clearfix">
                                                  <span class="price">
                                                    <span class="sign">£</span>
                                                    <span class="currency">0</span>
                                                    <span class="cent">.00</span>
                                                    <span class="month">/month</span>
                                                  </span>
                                                </div>
                                              </div>
                                              <div class="generic_feature_list">
                                                <ul>
                                                  <li>0.72 pence per minute to UK 01,02,03 Local and National</li>
                                                  <li>1.95 pence per minute to UK Mobiles</li>
                                                  <li>All other calls calculated as per the tariff (available upon request)</li>
                                                </ul>
                                              </div>
                                              <div class="generic_price_btn clearfix">
                                                <a class="" v-on:click="setCallOption('PAYG Calls')">Select</a>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-lg-4">
                                            <div v-bind:class="{active : order.callOption === '£8.95 Unlimited Calls*' }" class="generic_content clearfix">
                                              <div class="generic_head_price clearfix">
                                                <div class="generic_head_content clearfix">
                                                  <div class="head_bg"></div>
                                                  <div class="head">
                                                    <span>Unlimited Calls*</span>
                                                  </div>
                                                </div>
                                                <div class="generic_price_tag clearfix">
                                                  <span class="price">
                                                    <span class="sign">£</span>
                                                    <span class="currency">8</span>
                                                    <span class="cent">.95</span>
                                                    <span class="month">/month</span>
                                                  </span>
                                                </div>
                                              </div>
                                              <div class="generic_feature_list">
                                                <ul>
                                                  <li>*Unlimited calls to UK 01,02,03 Local and National and UK Mobiles only</li>
                                                </ul>
                                              </div>
                                              <div class="generic_price_btn clearfix">
                                                <a class="" v-on:click="setCallOption('£8.95 Unlimited Calls*')">Select</a>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-lg-4">
                                            <div v-bind:class="{active : order.callOption === '£10.95 Hosted Phone System User' }" class="generic_content clearfix">
                                              <div class="generic_head_price clearfix">
                                                <div class="generic_head_content clearfix">
                                                  <div class="head_bg"></div>
                                                  <div class="head">
                                                    <span>Hosted Phone System User</span>
                                                  </div>
                                                </div>
                                                <div class="generic_price_tag clearfix">
                                                  <span class="price">
                                                    <span class="sign">£</span>
                                                    <span class="currency">10</span>
                                                    <span class="cent">.95</span>
                                                    <span class="month">/month</span>
                                                  </span>
                                                </div>
                                              </div>
                                              <div class="generic_feature_list">
                                                <ul>
                                                  <li>Unlimited calls to UK 01,02,03 Local and National and UK Mobiles only</li>
                                                  <li>Includes full call routing, voicemail, mobile app, laptop app, call welcome &amp; out of hours routing</li>
                                                </ul>
                                              </div>
                                              <div class="generic_price_btn clearfix">
                                                <a class="" v-on:click="setCallOption('£10.95 Hosted Phone System User')">Select</a>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- <div class="col-md-4">
                                            <div v-bind:class="{active : order.callOption === '£10.95 Hosted Phone System User'}" class="generic_content clearfix">
                                              <div class="generic_head_price clearfix">
                                                <div class="generic_head_content clearfix">
                                                  <div class="head_bg"></div>
                                                  <div class="head">
                                                    <span>Hosted Phone System User</span>
                                                  </div>
                                                  <div class="generic_price_tag clearfix">
                                                    <span class="price">
                                                      <span class="sign">£</span>
                                                      <span class="currency">10</span>
                                                      <span class="cent">.95</span>
                                                      <span class="month">/month</span>
                                                    </span>
                                                  </div>
                                                </div>
                                                <div class="generic_feature_list">
                                                  <ul>
                                                    <li>Unlimited calls to UK 01,02,03 Local and National and UK Mobiles only</li>
                                                    <li>Includes full call routing, voicemail, mobile app, laptop app, call welcome &amp; out of hours routing</li>
                                                  </ul>
                                                </div>
                                                <div class="generic_price_btn clearfix">
                                                  <a class="" v-on:click="setCallOption('£10.95 Hosted Phone System User')">Select</a>
                                                </div>
                                              </div>
                                            </div>
                                          </div> -->
                                        </div>
                                      </div>
                                    </section>
                                  </div>

                                  <!-- <div class="row mb-2">
                                    <div class="col-md-4 text-center">
                                      <div style="height: 100%;" v-bind:class="{ optionBxSelected: order.callOption === 'PAYG Calls' }" v-on:click="setCallOption('PAYG Calls')" class="optionBx">
                                        <h5 class="text-ukit-secondary" style="font-weight:600;">PAYG Calls</h5>
                                        <p style="font-size: 10px;">0.72 pence per minute to UK 01,02,03 Local and National<br> 1.95 pence per minute to UK Mobiles<br>All other calls calculated as per the tariff (available upon request)</p>
                                      </div>
                                    </div>
                                    <div class="col-md-4 text-center">
                                      <div style="height: 100%;" v-bind:class="{ optionBxSelected: order.callOption === '£8.95 Unlimited Calls*' }" v-on:click="setCallOption('£8.95 Unlimited Calls*')" class="optionBx">
                                        <h5 class="text-ukit-secondary" style="font-weight:600;">£8.95 Unlimited Calls*</h5>
                                        <p style="font-size: 10px;">*Unlimited calls to UK 01,02,03 Local and National and UK Mobiles only</p>
                                      </div>
                                    </div>
                                    <div class="col-md-4 text-center">
                                      <div style="height: 100%;" v-bind:class="{ optionBxSelected: order.callOption === '£10.95 Hosted Phone System User' }" v-on:click="setCallOption('£10.95 Hosted Phone System User')" class="optionBx">
                                        <h5 class="text-ukit-secondary" style="font-weight:600;">£10.95 Hosted Phone System User</h5>
                                        <p style="font-size: 10px;">Unlimited calls to UK 01,02,03 Local and National and UK Mobiles only</p>
                                        <p style="font-size: 10px;">Includes full call routing, voicemail, mobile app, laptop app, call welcome &amp; out of hours routing</p>
                                        <p style="font-size: 10px;">If you’d like to discuss our hosted system prior to purchasing please select here:</p>
                                        <p style="font-size: 10px;"><i class="text-success fa fa-check"></i> Interested Only</p>
                                      </div>
                                    </div>
                                  </div> -->

                                  <div>
                                    <h5 style="display:inline-block; margin-right:20px;">Payment Details <small>(Please enter your DirectDebit details below)</small></h5>
                                    <div style="display:inline-block;">
                                      <a-switch checkedChildren="Pay By Invoice" unCheckedChildren="Pay By Invoice" size="small" style="margin-top:0px;" v-model="order.payByInvoice" @change="togglePayByInvoice()"/>
                                    </div>
                                    <v-row v-if="order.payByInvoice">
                                      <v-col cols="12">
                                        <h6 class="text-ukit-secondary" style="margin:16px 0 32px 0; font-weight:bold;">A monthly charge of £3.95 will be added to your invoice for non-DD payment method</h6>
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="!order.payByInvoice">
                                      <v-col cols="12" md="6">
                                        <v-subheader>Account Number</v-subheader>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-text-field  maxlength="8" required :rules="requiredRules" filled dense ref="accountNumber" v-model="order.accountNumber" label="Account Number" ></v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row v-if="!order.payByInvoice">
                                      <v-col cols="12" md="6">
                                        <v-subheader>Sort Code</v-subheader>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-text-field required  :rules="requiredShort" maxlength="2" type="tel" class="float-left" style="width:100px;" append-outer-icon="mdi-minus" dense ref="sortcode1" v-model="order.sortcode1" label="" @change="updateSortCode()"></v-text-field>
                                        <v-text-field required  :rules="requiredShort" maxlength="2" type="tel" class="float-left" style="width:100px; margin-left: 10px; margin-right: 10px;" append-outer-icon="mdi-minus" dense ref="sortcode2" v-model="order.sortcode2" label="" @change="updateSortCode()"></v-text-field>
                                        <v-text-field required  :rules="requiredShort" maxlength="2" type="tel" style="width:65px;" dense ref="sortcode3" v-model="order.sortcode3" label="" @change="updateSortCode()"></v-text-field>
                                      </v-col>
                                    </v-row>
                                    <div class="mr-4" style="float:left;">
                                      <h4>Billing Address</h4>
                                    </div>
                                    <div style="margin-top:12px; display:inline-block;">
                                      <a-switch checkedChildren="Same As Install" unCheckedChildren="Same As Install" size="small" style="margin-top:0px;" v-model="order.billingAddressSameAsInstall" @change="toggleSameBillingAddress()"/>
                                    </div>
                                    <div style="margin-top:20px;;" v-if="!order.billingAddressSameAsInstall">
                                      <v-text-field required :rules="requiredRules" filled dense ref="billingAddress" v-model="order.addresses[1].address" label="Address" ></v-text-field>
                                      <v-text-field filled dense ref="billingStreet" v-model="order.addresses[1].street" label="Street" ></v-text-field>
                                      <v-text-field required :rules="requiredRules" filled dense ref="billingCounty" v-model="order.addresses[1].county" label="County" ></v-text-field>
                                      <!-- <v-text-field dense ref="billingCountry" v-model="order.addresses[1].country" label="Country" ></v-text-field> -->
                                      <v-text-field required :rules="requiredRules" filled dense ref="billingPostcode" v-model="order.addresses[1].postcode" label="Post Code" ></v-text-field>
                                    </div>
                                    <div style="margin-top: 20px;" v-if="order.billingAddressSameAsInstall">
                                      {{ order.addresses[0].address }}, {{ order.addresses[0].street }}, {{ order.addresses[0].county }}, {{ order.addresses[0].postcode }}
                                    </div>
                                    <hr v-if="order.router != 'No Router Required'">
                                    <div v-if="order.router != 'No Router Required'" class="mr-4" style="float:left;">
                                      <h4>Router Delivery Address</h4>
                                    </div>
                                    <div v-if="order.router != 'No Router Required'" style="margin-top:12px; display:inline-block;">
                                      <a-switch checkedChildren="Same As Install" unCheckedChildren="Same As Install" size="small" style="margin-top:0px;" v-model="order.routerDeliveryAddressSameAsInstall" @change="toggleSameRouterDeliveryAddress()"/>
                                    </div>
                                    <div v-if="order.router != 'No Router Required' && !order.routerDeliveryAddressSameAsInstall" style="margin-top: 20px;">
                                      <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryAddress" v-model="order.addresses[2].address" label="Address" ></v-text-field>
                                      <v-text-field filled dense ref="routerDeliveryStreet" v-model="order.addresses[2].street" label="Street" ></v-text-field>
                                      <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryCounty" v-model="order.addresses[2].county" label="County" ></v-text-field>
                                      <!-- <v-text-field  dense ref="routerDeliveryCountry" v-model="order.addresses[2].country" label="Country" ></v-text-field> -->
                                      <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryPostcode" v-model="order.addresses[2].postcode" label="Post Code" ></v-text-field>
                                    </div>
                                    <div v-if="order.router != 'No Router Required' && order.routerDeliveryAddressSameAsInstall" style="margin-top: 20px;">
                                      {{ order.addresses[0].address }} {{ order.addresses[0].street }} {{ order.addresses[0].county }} {{ order.addresses[0].postcode }}
                                    </div>
                                  </div>

                                </v-col>
                              </v-row>
                              <hr v-if="!order.payByInvoice">
                              <v-row v-if="!order.payByInvoice">
                                <v-col>
                                  <h5>Direct Debit Guarantee</h5>
                                  <p style="font-size:12px; color: #000;">This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.
                                  If there are any changes to the amount, date or frequency of your Direct Debit, UKIT Networks will notify you three working days in advance of your account being debited or as otherwise agreed. If you request UKIT Networks to collect a payment, confirmation of the amount and date will be given to you at the time of the request.
                                  If an error is made in the payment of your Direct Debit by UKIT Networks or your bank or building society you are entitled to a full and immediate refund of the amount paid from your bank or building society.
                                  If you receive a refund you are not entitled to, you must pay it back when UKIT Networks asks you to. You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us.</p>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                          <div style="margin-top:-30px; margin-right:12px;" class="float-right">
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="previousStep()">Back</v-btn>
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="goToAgreement()">Next</v-btn>
                          </div>
                          <!-- <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="previousStep()" >Back</v-btn>
                            <v-btn class="mr-2 btn btn-ukit-primary" @click="completeOrder()" >Finish</v-btn>
                          </div> -->
                        </v-stepper-content>

                        <v-stepper-content step="4">
                          <div v-show="!orderCompleted">
                            <p class="text-center">By clicking Confirm Order, I agree to the terms and conditions (UK IT Networks Limited Terms &amp; Conditions v2.2) set out on your website <a href="https://ukitnetworks.com/terms-and-conditions" target="_blank">ukitnetworks.com/terms-and-conditions</a>, confirm that the information on this broadband order is correct, and I am authorised to sign for and behalf of {{ order.companyName }}. Until we notify you to the contrary, you may contact us by letter, telephone, fax, e-mail, sms or any other electronic means with regards to products and services offered by UK IT Networks Limited.</p>
                            <div class="row">
                              <div class=" col-md-12">
                                <div @scroll="handleScroll" class="tsAndCsContainer">
                                  <div style="position:absolute; top:-10px; right:15px; z-index:6000;">
                                    <span class="text-ukit-primary">Scroll Down To Agree to Ts and Cs</span> <i class="fa fa-arrow-down"></i>
                                  </div>
                                  <termsandconditions></termsandconditions>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 text-center">
                              <button v-if="!hasScrolledToBottom" disabled="disabled" class="disabled btn ">Agree To Terms</button>
                              <button v-on:click="completeOrder()" v-if="hasScrolledToBottom" class="btn btn-ukit-primary">Agree To Terms</button>
                            </div>
                          </div>
                          <div  v-show="orderCompleted">
                              <div class="col-md-4 offset-md-4">
                                <vue-recaptcha  @verify="verifyCaptcha" :loadRecaptchaScript="true" sitekey="6LdiF-IZAAAAADEsRPYbWcIGf3FssZBcFcKT3pKk">
                                </vue-recaptcha>
                              </div>
                              <div class="col-md-12">
                                <p class="text-center" style="margin-left: 35px;">By clicking here you confirm that the information on this order is correct, you are infact not a robot and are authorised to sign on behalf of your business</p>
                              </div>
                          </div>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                  </div>

                  <div class="col-md-4 pr-4" tyle="margin-top:8px;">
                    <div class="card p-2">
                      <div v-bind:class="{hideOrderUpdater: !orderUpdating}" class="orderUpdater">
                        <div class="orderUpdaterInternal text-center" style="color:#fff;">
                          <a-icon type="sync" spin />
                          <p>Updating Order</p>
                        </div>
                      </div>
                      <h4 class="text-ukit-primary text-center">Your Order</h4>
                      <table class="table table-striped">
                        <tbody>
                          <tr>
                            <td>{{ order.selectedQuote.productName }}</td>
                            <td class="text-ukit-primary">
                              <span v-if="order.termLength === '12 Months'">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband12monthMonthlyRental) }}</span>
                              <span v-if="order.termLength === '36 Months'">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband36monthMonthlyRental) }}</span>
                            </td>
                          </tr>
                          <tr v-if="order.selectedQuote.pricing.businessLineRentalRequired || order.selectedQuote.productName.includes('SOGEA')">
                            <td>Installation</td>
                            <td v-if="order.termLength === '36 Months'" class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.newBusinessLineInstallation36MONTHSCost) }}</td>
                            <td v-if="order.termLength === '12 Months'" class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.newBusinessLineInstallation12MONTHSCost) }}</td>
                          </tr>
                          <tr v-if="order.selectedQuote.pricing.businessLineRentalRequired">
                            <td>Business Monthly Line Rental</td>
                            <td class="text-ukit-primary">£{{ order.selectedQuote.pricing.businessLineRentalCost }}</td>
                          </tr>
                          <!-- <tr v-if="order.selectedQuote.pricing.businessLineRentalRequired">
                            <td>Discounted Business Calls*</td>
                            <td class="text-ukit-primary">INCLUDED</td>
                          </tr> -->
                          <tr v-if="order.orderType === 'Existing Line' || (order.termLength === '12 months' && order.selectedQuote.pricingbroadband12MonthConnectionCost != 0) || (order.termLength === '36 months' && order.selectedQuote.pricingbroadband36MonthConnectionCost != 0)">
                            <td>Connection Fee</td>
                            <td v-if="order.termLength === '12 Months'" class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband12MonthConnectionCost) }}</td>
                            <td v-if="order.termLength === '36 Months'" class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadband36MonthConnectionCost) }}</td>
                          </tr>
                          <tr v-if="order.router != 'No Router Required'">
                            <td>Router Monthly Rental<small></small></td>
                            <td class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.routerCost) }}</td>
                          </tr>
                          <tr v-if="order.orderType !== 'Existing Line'">
                            <td>Migration Fee</td>
                            <td class="text-ukit-primary">INCLUDED</td>
                          </tr>

                          <tr>
                            <td>Call Tariff</td>
                            <td>
                              <span v-if="order.callOption === 'PAYG Calls'">PAYG Calls</span>
                              <span v-if="order.callOption === '£8.95 Unlimited Calls*'">£8.95 Unlimited Calls*</span>
                              <span v-if="order.callOption === '£10.95 Hosted Phone System User'">£10.95 Hosted Phone System User</span>
                            </td>
                          </tr>

                        </tbody>
                      </table>

                      <table class="table">
                        <tbody>
                          <tr>
                            <td>One Off Total excl VAT</td>
                            <td>£{{ toTwoDecimalPlaces(order.totalOneOffCost) }}</td>
                          </tr>
                          <tr>
                            <td>Monthly Total excl VAT</td>
                            <td>£{{ toTwoDecimalPlaces(order.totalMonthlyCost) }}</td>
                          </tr>
                        </tbody>
                      </table>

                      <h4 class="text-ukit-primary text-center">{{ order.selectedQuote.productName }}</h4>
                      <div class="row text-center">
                        <div class="col-md-6">
                          <strong>Download</strong><br>
                          <span v-if="order.selectedQuote.productSpeed.estimatedDownloadRange.includes('-')">
                            <small>From: {{ formatHyphenatedMinToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatHyphenatedMaxToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }}</h3>
                          </span>
                          <span v-if="!order.selectedQuote.productSpeed.estimatedDownloadRange.includes('-')">
                            <small>From: {{ formatToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }}</h3>
                          </span>
                        </div>
                        <div class="col-md-6">
                          <strong>Upload</strong><br>
                          <span v-if="order.selectedQuote.productSpeed.estimatedUploadRange.includes('-')">
                            <small>From: {{ formatHyphenatedMinToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatHyphenatedMaxToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }}</h3>
                          </span>
                          <span  v-if="!order.selectedQuote.productSpeed.estimatedUploadRange.includes('-')">
                            <small>From: {{ formatToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }}</h3>
                          </span>
                        </div>
                        <button v-on:click="startAgain()" class="btn btn-ukit-secondary btn-block mr-4 ml-4">Start Again</button>
                      </div>
                    </div>

                    <div class="card p-2">
                      <h4 class="text-ukit-secondary text-center">What's Included?</h4>
                      <table class="table table-striped">
                        <tbody>
                          <tr>
                            <td>Dedicated UK Account Manager</td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                          <tr>
                            <td>Online Billing Platform Access</td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                          <tr>
                            <td>UK Based Support Desk</td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                          <tr>
                            <td>End Of Contract Notifications</td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                          <tr>
                            <td>Broadband Router Security <small>(optional)</small></td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                          <tr>
                            <td>Low Cost Call Options</td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                          <tr>
                            <td>Business Static IP Address</td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                          <tr>
                            <td>Unlimited Broadband Usage</td>
                            <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bbc_promoContainer">
                <zoom-center-transition>
                  <div v-if="stage === 'showDeals'" class="results" style="width:100%; height:100%; padding:15px;">
                    <div v-if="filteredQuotes.length" class="float-right">
                      <div class="form-check float-left mr-2">
                        <input v-model="quoteFilter.includeADSL" type="checkbox" class="form-check-input" id="filterAdsl">
                        <label class="form-check-label" style="font-size:12px;">Include ADSL</label>
                      </div>
                      <div class="form-check float-left mr-2">
                        <input v-model="quoteFilter.includeSOGEA" type="checkbox" class="form-check-input" id="filterSogea">
                        <label class="form-check-label" style="font-size:12px;">Include SOGEA</label>
                      </div>
                      <div class="form-check float-left">
                        <input v-model="quoteFilter.includeFTTC" type="checkbox" class="form-check-input" id="filterFttc">
                        <label class="form-check-label" style="font-size:12px;">Include FTTC</label>
                      </div>
                    </div>

                    <h3 v-if="filteredQuotes.length" class="text-ukit-secondary" style="text-align:left; padding-bottom:12px;">
                      Broadband Results
                      <button v-on:click="backToSearch()" class="btn btn-xs btn-ukit-secondary ml-3">Start Again</button>
                      <button v-on:click="toggleSpeedTest()" class="btn btn-xs btn-ukit-primary ml-3">Test Your Current Connection</button>
                      <button v-on:click="toggleQuickResults()" class="btn btn-xs btn-ukit-secondary ml-3">Email Me Results</button>
                    </h3>
                    <div v-if="filteredQuotes.length" class="row">
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Supplier</th>
                            <th>Product</th>
                            <th class="text-center">Download Speeds</th>
                            <th class="text-center">Upload Speeds</th>
                            <th class="text-center">Minimum Speed</th>
                            <th>Price</th>
                            <th class="text-center">Lead Time</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(quote,index) in filteredQuotes" v-bind:key="quote.productId">
                            <td><img src="resources/images/logos/uk_it_networks_x100.png" alt="UKIT Networks"></td>
                            <td class="productTblName text-ukit-secondary">
                              <span v-if="index != 0">
                                {{ quote.productName }}<v-icon style="margin: -2px 2px 0px 5px;" color="green darken-2" v-on:click="toggleSOGEAInfo()" v-if="quote.productName.includes('SOGEA')">info</v-icon>
                                <div v-if="quote.productName === 'Unlimited 80Mbps Fibre'" class="bg-ukit-secondary" style="border-radius:4px; float:right; padding:0px 10px 0px 10px;">
                                  <a-popover>
                                    <template slot="content">
                                      <div><i class="fa fa-info-circle" style="margin-right:5px;"></i>Most Selected Fibre Broadband</div>
                                    </template>
                                    <span class="text-white" style="font-weight: 600;">Favourite</span>
                                  </a-popover>
                                </div>
                              </span>
                              <span v-if="index === 0">
                                <div class="float-left mr-2 text-ukit-secondary">
                                  {{ quote.productName }}
                                  <v-icon style="margin: -2px 2px 0px 5px;" color="green darken-2" v-on:click="toggleSOGEAInfo()" v-if="quote.productName.includes('SOGEA')">info</v-icon>
                                </div>
                                <div class="bg-ukit-primary" style="border-radius:4px; float:right; padding:0px 10px 0px 10px;">
                                  <a-popover>
                                    <template slot="content">
                                      <div><i class="fa fa-info-circle" style="margin-right:5px;"></i>Lowest Cost For Quickest Speed</div>
                                    </template>
                                    <span class="text-white" style="font-weight: 600;">Best Value</span>
                                  </a-popover>
                                </div>
                              </span>
                            </td>
                            <td style="font-size:small; padding:5px;" class="text-center">
                              <strong class="mbl">Download Speeds: </strong>
                              <span v-if="quote.productSpeed.estimatedDownloadRange.includes('-')">{{ formatHyphenatedToMbps(quote.productSpeed.estimatedDownloadRange) }}</span>
                              <span v-if="!quote.productSpeed.estimatedDownloadRange.includes('-')">{{ formatToMbps(quote.productSpeed.estimatedDownloadRange) }}</span>
                            </td>
                            <td style="font-size:small; padding:5px;" class="text-center">
                              <strong class="mbl">Upload Speeds: </strong>
                              <span v-if="quote.productSpeed.estimatedUploadRange.includes('-')">{{ formatHyphenatedToMbps(quote.productSpeed.estimatedUploadRange) }}</span>
                              <span v-if="!quote.productSpeed.estimatedUploadRange.includes('-')">{{ formatToMbps(quote.productSpeed.estimatedUploadRange) }}</span>
                            </td>
                            <td style="font-size:small;" class="text-center text-ukit-primary">
                              <strong class="mbl">Minimum Speed: </strong>{{ formatToMbps(quote.productSpeed.minimumGuaranteedSpeed) }}
                            </td>
                            <td style="padding:5px;">
                              <div>
                                <span v-if="order.termLength === '12 Months'">£{{ toTwoDecimalPlaces(quote.pricing.broadband12monthMonthlyRental) }}<span style="font-size:small;">/Month</span></span>
                                <span v-if="order.termLength === '36 Months'">£{{ toTwoDecimalPlaces(quote.pricing.broadband36monthMonthlyRental) }}<span style="font-size:small;">/Month</span></span>
                              </div>
                              <div style="font-size:small;">
                                <span v-if="order.orderType !== 'Existing Line' && order.termLength === '12 Months'" class="1">£{{ toTwoDecimalPlaces(quote.pricing.broadband12MonthConnectionCost) }}</span>
                                <span v-if="order.orderType !== 'Existing Line' && order.termLength === '36 Months'" class="2">£{{ toTwoDecimalPlaces(quote.pricing.broadband36MonthConnectionCost) }}</span>
                                <span v-if="order.orderType === 'Existing Line'" class="3">£{{ toTwoDecimalPlaces(quote.pricing.migrationSellRate) }} migration</span>
                              </div>
                            </td>
                            <td style="font-size:small; padding:5px;" class="text-center">
                              <strong class="mbl">Lead Time: </strong>
                              <span>{{ quote.leadTime | moment("calendar") }}</span>
                            </td>
                            <td class="text-center"><button v-on:click="selectBroadband(quote)" class="btn btn-ukit-primary btn-sm btn-block">Select</button></td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- <div v-for="quote in quotes" v-bind:key="quote.productId" class="col-md-4">
                        <div class="card p-2">
                          <h4  class="text-ukit-primary text-center">Business Fibre</h4>
                          <div class="row text-center">
                            <div class="col-md-6">
                              <strong>Download</strong><br>
                              <small>From: 16.25 to</small>
                              <h2 class="text-ukit-primary">26.88</h2>
                            </div>
                            <div class="col-md-6">
                              <strong>Upload</strong><br>
                              <small>From: 16.25 to</small>
                              <h2 class="text-ukit-primary">26.88</h2>
                            </div>
                            <button v-on:click="selectBroadband(quote)" class="btn btn-ukit-primary btn-block mr-4 ml-4">Select Broadband</button>
                          </div>
                          <div style="font-size:8px;">{{ quote }}</div>
                        </div>
                      </div> -->
                    </div>

                    <div v-else class="row" id="no-line-error">
                      <img src="resources/images/broken_router.png" alt="Broken Router" id="line-error-image">
                      <h3>We're sorry, an error seems to have occurred</h3>
                      <v-btn class="mr-2 btn btn-ukit-secondary" @click="backToSearch()"><i class="fa fa-refresh"></i> Try Again</v-btn>
                    </div>
                  </div>
                </zoom-center-transition>

                <div v-if="!isLoading && stage === 'fetchingDeals'" class="results" style="height:300px;">
                  <span></span>
                </div>

                <zoom-center-transition>
                  <div v-if="stage === 'pickAddress' || stage === 'addressSearch'" class="bbc_promobg">
                    <div class="addressSlideIn">

                      <zoom-center-transition>
                        <div v-if="stage === 'pickAddress'" class="bbc_addressList">
                          <div v-on:click="backToSearch()" class="text-white bg-ukit-primary" style="cursor:pointer; position:absolute; top:0px; right:0px; padding:0 10px;">Back >></div>
                          <table class="table table-striped table-hover" style="cursor:pointer">
                            <tbody>
                              <!-- <tr v-on:click="selectAddress(address, index)" :key="address.index" v-for="address in addresses">
                                <td style="text-align: left;">{{ address.building_number + ' ' + address.building_name + ' ' + address.thoroughfare + ' ' + address.dependant_locality + ' ' + address.post_town + ' ' + address.postcode }}</td>
                              </tr> -->
                              <tr v-on:click="selectAddress(address, index)" :key="address.index" v-for="address in addresses">
                                <td style="text-align: left;">{{ parseAddress(address) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </zoom-center-transition>

                      <zoom-center-transition>
                        <div v-if="stage === 'addressSearch'" class="bbc_addressSearch" :class="{bbc_expanded : stage === 'pickPostCode'}">
                          <div>
                            <a-form :form="addressSearchForm">
                              <a-row>
                                <a-col class="pr-3 pl-3" :sm="12" :md="8">
                                  <a-form-item>
                                    <template slot="label">
                                      <i class="fa fa-asterisk text-ukit-primary mr-1"></i> <span class="text-ukit-secondary" style="font-size: 17px;">Installation Type</span>
                                    </template>
                                    <a-select size="large" default-value="New Line" @change="lineTypeChange"  v-model="order.orderType">
                                      <a-select-option value="New Line">New Line</a-select-option>
                                      <a-select-option value="Existing Line">Existing Line</a-select-option>
                                    </a-select>
                                  </a-form-item>
                                </a-col>
                                <a-col class="pr-3 pl-3" :sm="12" :md="8">
                                  <a-form-item class="noColonAfter" v-if="order.orderType === 'Existing Line'">
                                    <template class="" colon="false"  slot="label">
                                      <i class="fa fa-phone text-ukit-primary mr-1"></i> <span class="text-ukit-secondary" style="font-size: 17px;">Landline (e.g. 02081234567)</span>
                                    </template>
                                    <a-input @keydown="clearsearchFieldErrorMessage()"  v-decorator="['note', { rules: [{ required: true, message: 'Please enter a phone number!' }] }]" colon="false" v-model="landline" size="large"/>
                                  </a-form-item>
                                  <a-form-item   v-if="order.orderType === 'New Line'">
                                    <template slot="label">
                                      <i class="fa fa-home text-ukit-primary mr-1"></i> <span class="text-ukit-secondary" style="font-size: 17px;">Post Code</span>
                                    </template>
                                    <a-input @keydown="clearsearchFieldErrorMessage()" v-decorator="['note', { rules: [{ required: true, message: 'Please enter a post code!' }] }]" v-model="postcode" size="large"/>
                                    <span v-if="searchFieldErrorMessage != ''" class="text-danger">{{ '*' + searchFieldErrorMessage }}</span>
                                  </a-form-item>
                                </a-col>
                                <a-col class="pr-3 pl-3"  :sm="12" :md="8">
                                  <a-button v-if="order.orderType === 'New Line'" @click="search" class="btn-block btn-ukit-secondary" style="margin-top: 47px;" size="large" type="primary" html-type="submit">Search</a-button>
                                  <a-button v-if="order.orderType === 'Existing Line'" @click="searchMigration" class="btn-block btn-ukit-secondary" style="margin-top: 47px;" size="large" type="primary" html-type="submit">Search</a-button>
                                </a-col>
                              </a-row>
                            </a-form>
                          </div>
                          <!-- <h5 class="text-center" style="margin-bottom:0px;">Lets get started</h5>
                          <v-form ref="entryForm" v-model="isValid" class="bbc_zeroTop">
                            <v-container class="bbc_zeroTop">
                              <v-row class="bbc_zeroTop">
                                <v-col class="bbc_zeroTop" cols="12" md="12">
                                  <v-select :items="orderTypes" item-text="New Line" item-value="New Line" v-model="order.orderType" label="Type"></v-select>
                                  <v-text-field v-if="order.orderType != 'Migration'" class="bbc_zeroTop" ref="postcode" v-model="postcode" :rules="[() => !!postcode || 'This field is required']" label="Post Code"></v-text-field>
                                  <v-text-field v-if="order.orderType === 'Migration'" ="bbc_zeroTop" ref="landline" v-model="landline" label="Landline (e.g: 02081234567)"></v-text-field>
                                  <v-btn v-if="order.orderType === 'Migration'" class="bbc_zeroTop" :disabled="!isValid" color="success" @click="searchMigration">Search</v-btn>
                                  <v-btn v-if="order.orderType != 'Migration'" class="bbc_zeroTop" :disabled="!isValid" color="success" @click="search">Search</v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form> -->
                        </div>
                      </zoom-center-transition>

                    </div>
                  </div>
                </zoom-center-transition>
              </div>
            </div>

          </div>
          <!-- <div class="row">
            <div clas="col-md-12 text-center mt-4"></div>
          </div> -->
          <div class="row">
            <div class="col-md-12 pt-0  text-center">
              <a target="_blank" href="http://www.ravenware.co.uk"><img src="resources/poweredByRavenware.png" alt="Powered by Ravenware ltd"></a>
            </div>
          </div>
        </div>

        <div id="carousel-wrap">
          <carousel :items="7" :margin="100" :loop="true" :nav="false" :autoplay="true" :autoplaySpeed="3000">
            <img src="resources/images/logos/bt-wholesale.png">
            <img src="resources/images/logos/virgin-media.png">
            <img src="resources/images/logos/cisco.png">
            <img src="resources/images/logos/cityfibre.png">
            <img src="resources/images/logos/openreach.png">
            <img src="resources/images/logos/talktalk-business.png">
            <img src="resources/images/logos/colt.png">
            <img src="resources/images/logos/vodafone.png">
            <img src="resources/images/logos/virtual1.png">
            <img src="resources/images/logos/sse.png">
          </carousel>
        </div>

        <div class="deals-wrap">
          <div class="row">
            <div class="col-4">
              <div class="deal">
                <div class="deal-top">
                  <h6>Lowest Cost</h6>
                  <p class="deal-product">Unlimited Business Broadband</p>
                  <p class="deal-price">From <strong>£7.95</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Up to 24Mbps Speeds</p>
                  <p><i class="fa fa-check"></i> Unlimited Downloads</p>
                  <p><i class="fa fa-check"></i> Static IP Address</p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="deal focus">
                <div class="deal-top">
                  <h6>Most Popular</h6>
                  <p class="deal-product">Unlimited Fibre Broadband</p>
                  <p class="deal-price">From <strong>£15.45</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Up to 80Mbps Speeds</p>
                  <p><i class="fa fa-check"></i> Unlimited Downloads</p>
                  <p><i class="fa fa-check"></i> Static IP Address</p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="deal">
                <div class="deal-top">
                  <h6>Best Value</h6>
                  <p class="deal-product">Unlimited G-Fast Broadband</p>
                  <p class="deal-price">From <strong>£41.95</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Up to 330Mbps Speeds</p>
                  <p><i class="fa fa-check"></i> Unlimited Downloads</p>
                  <p><i class="fa fa-check"></i> Static IP Address</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="faqs-wrap">
          <div class="row">
            <div class="col-3 faq-questions">
              <h4>Frequently Asked Questions</h4>
              <div class="questions">
                <div v-for="(faq,index) in faqs" v-bind:key="index" class="faq-question" v-on:click="selectFaq(index)">
                  <h6 v-if="selectedFaq == index" class="selected"><i class="fa fa-question-circle"></i> {{ faq.question }}</h6>
                  <h6 v-else><i class="fa fa-question-circle"></i> {{ faq.question }}</h6>
                </div>
              </div>
            </div>
            <div class="col-9 faq-answers">
              <div class="answers">
                <div v-for="(faq,index) in faqs" v-bind:key="index" class="faq-answer">
                  <div v-if="selectedFaq == index" class="answer-wrap">
                    <div class="answer">
                      <h5>{{ faq.question }}</h5>
                      <p>{{ faq.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
            </div>
          </div>
        </div>

        <div class="benefits-wrap">
          <div class="row">
            <div class="col-3">
              <img src="resources\images\icons\deals\unlimited_broadband_x100.png">
              <h6>Unlimited Broadband Usage</h6>
              <p>Enjoy unlimited business broadband data usage without any additional charges.</p>
            </div>
            <div class="col-3">
              <img src="resources\images\icons\deals\low_cost_call_options_x100.png">
              <h6>Low Cost Call Options</h6>
              <p>Save with PAYG or low-cost call bundle options, keeping business costs down.</p>
            </div>
            <div class="col-3">
              <img src="resources\images\icons\deals\broadband_router_security_x100.png">
              <h6>Broadband Router Security</h6>
              <p>Keep your infrastructure secure and safe from attacks on your network.</p>
            </div>
            <div class="col-3">
              <img src="resources\images\icons\deals\uk_account_manager_x100.png">
              <h6>UK Based Support Desk</h6>
              <p>Benefit from 24/7/365 support with our friendly UK-based support team.</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div id="footer-top">
      <h6>Need some assistance? We can help.</h6>
      <v-btn href="/about-us">Find out more</v-btn>
    </div>

    <div id="footer-bottom">
      <div class="row">
        <div class="col-md-3">
          <img class="footer-logo" src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo">
        </div>
        <div class="col-md-9">
          <ul class="footer-menu">
            <li><a href="https://ukitnetworks.com/privacy-policy/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2479">Privacy Policy v1.0</a></li>
            <li><a href="/support" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-2542 current_page_item menu-item-2699">Customer Support</a></li>
            <li><a href="https://ukitnetworks.com/terms-and-conditions/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2478">Terms and Conditions</a></li>
          </ul>
          <div class="legal-details">
            <p>Registered in England and Wales: 8026657</p>
            <p>Ofcom Reseller ID: FLV</p>
            <p>ICO Reg Number: A422750</p>
            <p>VAT Reg Number: 121 9534 29</p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="social-icons">
            <a href="https://www.linkedin.com/company/uk-it-networks-limited">
              <i class="fa fa-linkedin-square"></i>
            </a>
            <a href="https://twitter.com/ukitnetworks?lang=en">
              <i class="fa fa-twitter-square"></i>
            </a>
            <a href="https://www.facebook.com/UKITNET/">
              <i class="fa fa-facebook-square"></i>
            </a>
          </div>
          <div class="contact-icons">
            <a href="tel:03443262154">
              <i class="fa fa-phone-square"></i>
            </a>
            <a href="mailto:info@ukbusinessbroadband.com">
              <i class="fa fa-envelope-square"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <a-modal :footer="null" v-model="showSoegeaInfo" title="SOGEA Explained" ok-text="OK" @ok="showSoegeaInfo=false">
      SOGEA <small>(Single Order Generic Etherner Access)</small> is a single order variant, meaning that there is no requirement for a business landline and the monthly costs associated. Please note however you cannot make calls on a SOGEA line without the use of a VoIP phone. Any questions please contact us on: <a href="call:03443262154">0344 326 2154</a>.
      <br>
      <br>
      <div style="margin-top:-20px;" class="float-right">
        <button class="btn btn-sm btn-ukit-primary" v-on:click="toggleSOGEAInfo()">OK</button>
      </div>
    </a-modal>

    <a-modal :width="650" :footer="null" v-model="showSpeedTest" title="Broadband Speed Test" ok-text="OK" @ok="showSpeedTest=false">
      <iframe frameBorder="0" src="https://openspeedtest.com/Get-widget.php" width="600" height="350" style="display:block; margin:auto;"></iframe>
      <br>
      <br>
      <div style="margin-top:-20px;" class="float-right">
        <button class="btn btn-sm btn-ukit-primary" v-on:click="toggleSpeedTest()">CLOSE</button>
      </div>
    </a-modal>

    <a-modal :width="650" :footer="null" v-model="showQuickResults" title="Email Me Results" ok-text="OK" @ok="showQuickResults=false">
      <div id="quick-quote">
        <v-text-field v-if="!quickQuoteSent" v-model="order.quickQuoteEmailAddress" ref="quickQuoteEmailAddress" label="Email Address" ></v-text-field>
        <button v-if="!quickQuoteSent && order.quickQuoteEmailAddress === ''" class="btn btn-ukit-secondary btn-sm" disabled>Send Results</button>
        <button v-if="!quickQuoteSent && order.quickQuoteEmailAddress !== ''" v-on:click="emailQuoteResults()" class="btn btn-ukit-secondary btn-sm">Send Results</button>
        <h4 v-if="quickQuoteSent">Thank you, your quote results have been emailed to you</h4>
      </div>
      <br>
      <br>
      <div style="margin-top:-20px;" class="float-right">
        <button class="btn btn-sm btn-ukit-primary" v-on:click="toggleQuickResults()">CLOSE</button>
      </div>
    </a-modal>

  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import _ from 'lodash'
import { ZoomCenterTransition } from 'vue2-transitions'
import termsandconditions from '@/components/tenant/ukittermsandconditions'
import carousel from 'vue-owl-carousel'

export default {
  name: 'Home',
  components: {
    Loading,
    ZoomCenterTransition,
    termsandconditions,
    carousel,
    VueRecaptcha,
  },

  mounted() {
    this.mounted = true
    this.$nextTick(function() {
      this.iframeHeightChangeNotifyParent()
    })
    this.getBrowserUsed()
    setTimeout(
      function() {
        this.iframeHeightChangeNotifyParent()
      }, 6000)
  },

  computed: {
    filteredQuotes: function() {
      let retARR
      if (this.order.termLength === '12 Months') {
        retARR = this.quotes.filter(q => this.displayQuote(q))
          .sort((b, a) => a.productSpeed.minimumGuaranteedSpeed - b.productSpeed.minimumGuaranteedSpeed || b.pricing.broadband12monthMonthlyRental - a.pricing.broadband12monthMonthlyRental)
      } else {
        retARR = this.quotes.filter(q => this.displayQuote(q))
          .sort((b, a) => a.productSpeed.minimumGuaranteedSpeed - b.productSpeed.minimumGuaranteedSpeed || b.pricing.broadband36monthMonthlyRental - a.pricing.broadband36monthMonthlyRental)
      }
      return retARR
    },

  },

  created() {
    window.addEventListener('resize', this.windowResized)

    // if (this.$route.query.tid) {
    //   this.params.tid = this.$route.query.tid
    // }
    this.params.tid = '2807F490-5E8A-46BE-9718-0172CCB13B4F'
  },

  watch: {},

  methods: {
    verifyCaptcha(e) {
      this.order.vid = e
      this.captchaComplete()
    },

    transitionOrderUpdate() {
      this.orderUpdating = true
      var that = this
      setTimeout(function() {
        that.orderUpdating = false
      }, 500)
    },

    testTransition() {
      this.orderUpdating = false
    },

    setCallOption(val) {
      this.order.callOption = val
      this.calcTotals()
    },

    clearsearchFieldErrorMessage() {
      this.searchFieldErrorMessage = ''
    },

    postCodeEntered() {
      var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i
      this.searchFieldErrorMessage = 'Please enter a valid post code.'
      return postcodeRegEx.test(this.postcode)
    },

    phoneNumberEntered() {
      let isnum = /^\d+$/.test(this.landline)
      this.searchFieldErrorMessage = 'Please enter a valid post code.'
      return isnum
    },

    toggleSpeedTest() {
      if (this.showSpeedTest) {
        this.showSpeedTest = false
      } else {
        this.showSpeedTest = true
      }
    },

    toggleQuickResults() {
      if (this.showQuickResults) {
        this.showQuickResults = false
      } else {
        this.showQuickResults = true
      }
    },

    getBrowserUsed() {
      this.order.browserUsed = 'xx'
    },

    toggleLoading() {
      if (this.isLoading === true) {
        this.isLoading = false
      } else {
        this.isLoading = true
      }
    },

    termChanged() {
      this.calcTotals()
    },

    calcTotals() {
      this.transitionOrderUpdate()
      if (this.order.termLength === '12 Months') {
        if (this.order.router === 'Technicolor Wireless') {
          this.order.routerCost = 6.95
        } else {
          this.order.routerCost = 0.00
        }
        this.order.totalOneOffCost = parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.broadband12MonthConnectionCost)) + parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.newBusinessLineInstallation12MONTHSCost))
        this.order.totalMonthlyCost = parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.broadband12monthMonthlyRental)) + parseFloat(this.toTwoDecimalPlaces(this.order.routerCost)) + parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.businessLineRentalCost))
      } else {
        if (this.order.router === 'Technicolor Wireless') {
          this.order.routerCost = 2.35
        } else {
          this.order.routerCost = 0.00
        }
        this.order.totalOneOffCost = parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.broadband36MonthConnectionCost)) + parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.newBusinessLineInstallation36MONTHSCost))
        this.order.totalMonthlyCost = parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.broadband36monthMonthlyRental)) + parseFloat(this.toTwoDecimalPlaces(this.order.routerCost)) + parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.businessLineRentalCost))
      }// add on tariff price
      if (this.order.callOption === '£10.95 Hosted Phone System User') {
        this.order.totalMonthlyCost = parseFloat(this.order.totalMonthlyCost) + parseFloat(10.95)
      } else if (this.order.callOption === '£8.95 Unlimited Calls*') {
        this.order.totalMonthlyCost = parseFloat(this.order.totalMonthlyCost) + parseFloat(8.95)
      }
    },

    routerChanged(val) {
      this.calcTotals()
    },

    handleScroll: function(el) {
      if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        this.hasScrolledToBottom = true
      }
    },

    lineTypeChange(value) {
      // reset form.
      this.addressSearchForm.resetFields()
      if (value === 'New Line') {
        this.order.newLineRequired = true
      } else {
        this.order.newLineRequired = false
      }

      this.calcTotals()
    },

    toTwoDecimalPlaces: function(value) {
      if (value === null) {
        return 0.00
      } else {
        return parseFloat(value).toFixed(2)
      }
    },

    windowResized: _.debounce(function(e) {
      let width = document.getElementById('ravenwareSite').scrollWidth
      if (width !== this.windowSize.width) {
        this.windowSize.width = document.getElementById('ravenwareSite').scrollWidth
        this.iframeHeightChangeNotifyParent()
      }
    }, 1),

    iframeHeightChangeNotifyParent: _.debounce(function(e) {
      let height
      let el = document.getElementById('ravenwareSite')
      if (el != null) {
        height = document.getElementById('ravenwareSite').scrollHeight
      } else {
        height = 200
      }
      window.parent.postMessage({ frameHeight: height }, '*')
    }, 1),

    iframeHeightSpecificSizeNotifyParent(height) {
      window.parent.postMessage({ frameHeight: height }, '*')
    },

    toggleSOGEAInfo() {
      if (this.showSoegeaInfo === true) {
        this.showSoegeaInfo = false
      } else {
        this.showSoegeaInfo = true
      }
    },

    displayQuote(quote) {
      let display = true
      if (quote.daisyProductName.includes('SOGEA') && this.quoteFilter.includeSOGEA === false) {
        display = false
      }
      if (quote.daisyProductName.includes('ADSL') && this.quoteFilter.includeADSL === false) {
        display = false
      }
      if ((quote.daisyProductName.includes('FTTC') && !quote.daisyProductName.includes('SOGEA')) && this.quoteFilter.includeFTTC === false) {
        display = false
      }
      return display
    },

    startAgain() {
      this.stage = 'addressSearch'
      this.iframeHeightChangeNotifyParent()
    },

    scrollToTop() {
      var el = this.$el.getElementsByClassName('wizardski')[0]

      if (el) {
        el.scrollIntoView()
      }
    },

    parseAddress(address) {
      return [address.subPremesis, address.building, address.street, address.locality, address.city, address.county, address.postcode].filter(Boolean).join(' ')
    },

    copyAuthDetailsToAccount() {
      this.order.accountsContactFirstName = this.order.authorisedContactFirstName
      this.order.accountsContactLastName = this.order.authorisedContactLastName
      this.order.accountsContactEmail = this.order.emailAddress
    },

    addressChange() {
      if (this.order.billingAddressSameAsInstall) {
        this.order.addresses[1].address = this.order.addresses[0].address
        this.order.addresses[1].street = this.order.addresses[0].street
        this.order.addresses[1].county = this.order.addresses[0].county
        //  this.order.addresses[1].country = this.order.addresses[0].country
        this.order.addresses[1].postcode = this.order.addresses[0].postcode
      }
    },

    togglePayByInvoice() {
      if (this.order.payByInvoice) {
        this.order.accountNumber = null
        this.order.sortcode = null
        this.order.sortcode1 = null
        this.order.sortcode2 = null
        this.order.sortcode3 = null
      }
    },

    updateSortCode() {
      this.order.sortcode = this.order.sortcode1 + '-' + this.order.sortcode2 + '-' + this.order.sortcode3
    },

    toggleSameBillingAddress() {
      if (!this.order.billingAddressSameAsInstall) {
        // this.order.billingAddressSameAsInstall = false
        this.order.addresses[1].address = null
        this.order.addresses[1].street = null
        this.order.addresses[1].county = null
        // this.order.addresses[1].country = null
        this.order.addresses[1].postcode = null
      } else {
        // this.order.billingAddressSameAsInstall = true
        this.order.addresses[1].address = this.order.addresses[0].address
        this.order.addresses[1].street = this.order.addresses[0].street
        this.order.addresses[1].county = this.order.addresses[0].county
        //  this.order.addresses[1].country = this.order.addresses[0].country
        this.order.addresses[1].postcode = this.order.addresses[0].postcode
      }
    },

    toggleSameRouterDeliveryAddress() {
      if (!this.order.routerDeliveryAddressSameAsInstall) {
        // this.order.routerDeliveryAddressSameAsInstall = false
        this.order.addresses[2].address = null
        this.order.addresses[2].street = null
        this.order.addresses[2].county = null
        // this.order.addresses[2].country = null
        this.order.addresses[2].postcode = null
      } else {
        // this.order.routerDeliveryAddressSameAsInstall = true
        this.order.addresses[2].address = this.order.addresses[0].address
        this.order.addresses[2].street = this.order.addresses[0].street
        this.order.addresses[2].county = this.order.addresses[0].county
        //  this.order.addresses[2].country = this.order.addresses[0].country
        this.order.addresses[2].postcode = this.order.addresses[0].postcode
      }
    },

    toggleExistingCustomer() {
      if (this.order.existingCustomer) {
        this.order.existingCustomer = false
        this.order.companyType = 'New Customer'
      } else {
        this.order.existingCustomer = true
        this.order.companyType = 'Existing Customer'
      }
      this.calcTotals()
    },

    completeOrder() {
      this.orderCompleted = true
    },

    captchaComplete() {
      this.toggleLoading()
      this.order.tid = this.params.tid
      this.$http.post('/api/broadband/raiseBroadbandOrder/', this.order)
        .then(response => {
          this.toggleLoading()
          // loader.hide()
          this.stage = 'thankyou'
          this.scrollToTop()
          this.iframeHeightChangeNotifyParent()
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    nextStep() {
      this.currentStep += 1
      this.scrollToTop()
    },

    goToInstall() {
      if (this.$refs.detailsForm.validate()) {
        this.currentStep = 2
        this.scrollToTop()
      }
    },

    goToOrder() {
      if (this.$refs.detailsForm.validate()) {
        this.currentStep = 3
        this.scrollToTop()
      }
    },

    goToAgreement() {
      if (this.$refs.installForm.validate()) {
        this.currentStep = 4
        this.scrollToTop()
      }
    },

    previousStep() {
      this.currentStep -= 1
      this.scrollToTop()
    },

    getAddressMatches() {
      // this.$nextTick(function() {
      //   this.iframeHeightChangeNotifyParent()
      // })
      this.toggleLoading()
      // let loader = this.$loading.show({ container: this.$refs.greenFrame ? null : this.$refs.formContainer, onCancel: this.onCancel, color: '#B9D253' })
      let address = { postcode: this.postcode, paramCarrier: this.params }
      this.$http.post('/api/broadband/addressLookup/', address)
        .then(response => {
          this.toggleLoading() // loader.hide()
          this.addresses = response.data
          this.iframeHeightChangeNotifyParent()
        })
        .catch(e => {
          this.errors.push(e)
        })

      // this.$http.get('https://api.ideal-postcodes.co.uk/v1/postcodes/' + this.postcode, {headers: { 'Authorization': 'IDEALPOSTCODES api_key="xxxx"' }})
      // .then(response => {
      //     this.addresses = response.data.result
      // })
      // .catch(e => {
      // this.errors.push(e)
      // })
    },

    search(e) {
      this.searchFieldErrorMessage = ''
      if (this.postCodeEntered() !== true) {
        return false
      }
      e.preventDefault()
      this.addressSearchForm.validateFields((err, values) => {
        if (!err) { // check form for missing fields.
          this.stage = 'pickAddress'
          this.iframeHeightChangeNotifyParent()
          this.$nextTick(function() {
            this.getAddressMatches()
          })
        }
      })
    },

    searchMigration(e) {
      this.searchFieldErrorMessage = ''
      if (this.phoneNumberEntered() !== true) {
        return false
      }
      e.preventDefault()
      this.addressSearchForm.validateFields((err, values) => {
        if (!err) { // check form for missing fields.
          this.stage = 'fetchingDeals'
          this.iframeHeightChangeNotifyParent()
          let address = { cli: this.landline }
          this.getQuotes(address)
        }
      })
    },

    backToSearch() {
      this.stage = 'addressSearch'
      this.quickQuoteSent = true
      this.iframeHeightChangeNotifyParent()
    },

    selectAddress(address) {
      // fetch quotes..
      this.stage = 'fetchingDeals'
      this.iframeHeightSpecificSizeNotifyParent(380)
      this.selectedAddress = address

      // set install address
      this.order.addresses[0].address = [address.subPremesis, address.building].filter(Boolean).join(' ')
      this.order.addresses[0].street = address.street
      this.order.addresses[0].county = address.county
      // this.order.addresses[0].country = address.country
      this.order.addresses[0].postcode = address.postcode
      // set billing address
      this.order.addresses[1].address = [address.subPremesis, address.building].filter(Boolean).join(' ')
      this.order.addresses[1].street = address.street
      this.order.addresses[1].county = address.county
      // this.order.addresses[1].country = address.country
      this.order.addresses[1].postcode = address.postcode
      this.$nextTick(function() {
        this.getQuotes(this.selectedAddress)
      })
      // setTimeout(function() {
      //   this.getQuotes(this.selectedAddress)
      // }, 5000)
      // wait
      // return results.
      // setTimeout(() => this.stage = 'showDeals', 5000);
    },

    getQuotes(address) {
      // let loader = this.$loading.show({ container: this.$refs.greenFrame, onCancel: this.onCancel, color: '#B9D253' })
      let broadbandLookupRequest = { paramCarrier: this.params, address: address }
      this.toggleLoading()
      this.$http.post('/api/broadband/quotesLookup/', broadbandLookupRequest)
        .then(response => {
          this.stage = 'showDeals'
          // loader.hide()
          this.quotes = response.data.products
          this.iframeHeightChangeNotifyParent()
          this.toggleLoading()
        })
        .catch(e => {
          // revert and allow another try.
          this.stage = 'addressSearch'
          this.toggleLoading()
          this.$message.error('There has been an error returning quotes. Please try again')
        })
    },

    selectBroadband(quote) {
      this.order.selectedQuote = quote
      this.stage = 'order'
      this.quickQuoteSent = false
      this.setFormattedValues(quote)
      this.calcTotals()
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
        this.scrollToTop()
      })
    },

    emailQuoteResults() {
      let broadbandQuotes = {
        products: this.filteredQuotes,
        tid: this.params.tid,
        termLength: this.order.termLength,
        emailAddress: this.order.quickQuoteEmailAddress,
        address: this.order.addresses[0],
      }

      this.$http.post('/api/broadband/emailCustomerBroadbandQuotes/', broadbandQuotes)
        .then(response => {
          this.iframeHeightChangeNotifyParent()
          this.quickQuoteSent = true
        })
        .catch(e => {
          this.errors.push(e)
          alert('Error')
        })
    },

    backToBroadbandSelect() {
      this.stage = 'showDeals'
      this.iframeHeightChangeNotifyParent()
    },

    setFormattedValues(quote) {
      // format download
      if (quote.productSpeed.estimatedDownloadRange.includes('-')) {
        quote.productSpeed.formattedEstimatedDownloadRange = this.formatHyphenatedToMbps(quote.productSpeed.estimatedDownloadRange)
      } else {
        quote.productSpeed.formattedEstimatedDownloadRange = this.formatToMbps(quote.productSpeed.estimatedDownloadRange)
      }
      // format upload
      if (quote.productSpeed.estimatedUploadRange.includes('-')) {
        quote.productSpeed.formattedEstimatedUploadRange = this.formatHyphenatedToMbps(quote.productSpeed.estimatedUploadRange)
      } else {
        quote.productSpeed.formattedEstimatedUploadRange = this.formatToMbps(quote.productSpeed.estimatedUploadRange)
      }
      // format upload
      quote.productSpeed.formattedMinimumGuaranteedSpeed = this.formatToMbps(quote.productSpeed.minimumGuaranteedSpeed)
    },

    formatHyphenatedToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[1] / 1000).toFixed(2) + 'Mbps - ' + (arr[0] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatHyphenatedMinToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[0] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatHyphenatedMaxToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[1] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatToMbps(value) {
      if (value <= 0) { value = 0 }
      return (value / 1000).toFixed(2) + 'Mbps'
    },

    selectFaq(index) {
      this.selectedFaq = index
    },
  },

  beforeCreate() {
    this.addressSearchForm = this.$form.createForm(this, { name: 'addressSearch' })
  },

  data: () => ({
    orderCompleted: false,
    e1: 1,
    orderUpdating: false,
    searchFieldErrorMessage: '',
    windowSize: { width: 0 },
    requiredShort: [
      v => !!v || 'required',
    ],
    requiredRules: [
      v => !!v || 'This field is required',
    ],
    installFormValid: true,
    detailsFormValid: true,
    orderFormValid: true,
    showSpeedTest: false,
    showQuickResults: false,
    browserUsed: 'unknown',
    isLoading: false,
    hasScrolledToBottom: false,
    params: { source: null, tid: null },
    loadski: true,
    mounted: false,
    API_URL: null,
    showSoegeaInfo: false,
    quoteFilter: { includeSOGEA: true, includeADSL: true, includeFTTC: true },
    orderTypes: ['New Line', 'Migration'],
    quotes: null,
    selectedAddress: null,
    testxx: null,
    sortcode: null,
    sortcode1: null,
    sortcode2: null,
    sortcode3: null,
    differentBillingDetails: false,
    callOptions: ['PAYG Calls', '£8.95 Unlimited Calls*', '£10.95 Hosted Phone System User'],
    order: {
      callOption: 'PAYG Calls',
      companyType: 'New Customer',
      totalOneOffCost: 0.00,
      totalMonthlyCost: 0.00,
      routerCost: 0.00,
      router: 'No Router Required',
      //   newLineRequired: true,
      termLength: '36 Months',
      orderType: 'New Line',
      accountNumber: null,
      sortcode: null,
      customerNumber: null,
      existingCustomer: false,
      selectedQuote: null,
      payByInvoice: false,
      billingAddressSameAsInstall: true,
      routerDeliveryAddressSameAsInstall: true,
      companyName: null,
      emailAddress: null,
      quickQuoteEmailAddress: null,
      accountSite: null,
      phoneNumber: null,
      faxNumber: null,
      website: null,
      numberOfEmployees: null,
      registeredNumber: null,
      billingMethod: null,
      authorisedContactName: null,
      authorisedContactEmail: null,
      authorisationAccess: null,
      accountsContactFirstName: null,
      accountsContactLastName: null,
      accountsContactEmail: null,
      accountsContactTelephone: null,
      crmAccountNumber: null,
      addresses: [
        { type: 'install', address: null, street: null, county: null, country: 'United Kindgom', postcode: null },
        { type: 'billing', address: null, street: null, county: null, country: 'United Kindgom', postcode: null },
        { type: 'routerDelivery', address: null, street: null, county: null, country: 'United Kindgom', postcode: null },
      ],
    },
    currentStep: 1,
    showLoading: true,
    addresses: [],
    postcode: null,
    landline: '',
    rules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 characters',
    ],
    // stages addressSearch , pickAddress
    searchData: { postcode: null, landLine: null },
    stage: 'addressSearch',
    isValid: false,
    quickQuoteSent: false,
    revealEmailAddress: null,
    faqs: [
      { question: 'What Is Fibre to the Cabinet (FTTC) Business broadband?', answer: 'Fibre to the Cabinet (FTTC) from UK IT Networks is where a fibre optic cable is delivered to a green cabinet The customer is connected to the Green Cabinet via traditional copper, also referred to as a Business Analogue Line. Broadband and analogue lines  orders are being replaced by SoGEA orders (Single Order Generic Ethernet Access).' },
      { question: 'What speeds are available on Business broadband FTTC connections?', answer: 'The highest speeds you can expect on a FTTC business connection is 80Mbps downstream and 20Mbps Upstream. For quicker business broadband speeds FTTP (Fibre To The Premises) may be available.' },
      { question: 'What speeds are guaranteed on my FTTC business broadband connection?', answer: 'As FTTC speeds are distance dependant we cannot guarantee the full 80Mbps downstream speeds. Ultimately the nearer you are to the street cabinet the faster the FTTC speeds you will receive. Using our broadband checker, we advise your FTTC best speeds, worst speeds and our minimum commitment speed.' },
      { question: 'Are FTTC Business Broadband connections effected by ‘busy-times’?', answer: 'FTTC is a shared bandwidth service meaning there is a possibility your business broadband speeds could slow down during peak times.' },
      { question: 'Dedicated Business Broadband Options?', answer: 'If FTTC business broadband doesn’t provide you the dedicated speeds you require, you will need consider EFM (Ethernet First Mile) or a and dedicated business Ethernet Leased Line.' },
      { question: 'What is Fibre to the Premises (FTTP) Business Broadband?', answer: 'Fibre to the Premises (FTTO) provides a end-to-end fibre optic connection from the local exchange to your business and can deliver much faster speeds than FTTC as there is no limitation, like with a copper line.' },
      { question: 'What speeds are available on Business FTTP broadband connections?', answer: 'Should your business be in an area where Business FTTP is available, your business may be able to obtain speeds up to 330Mbps downstream and 30Mbps Upstream.' },
      { question: 'What are the benefits of FTTP business broadband or FTTC business broadband from you?', answer: 'Our FTTC and FTTP connections have no data download limitations. The speeds offered are the fastest available using FTTx technology. You will receive 24x7x365 UK customer support, a static IP address and a dedicated UK account manager for any business support.' },
      { question: 'Is there a minimum contract term on your FTTx business broadband connections?', answer: 'Our typical contract term options are 12 months, 24 months and 36 months. Typically the longer the business broadband commitment the lower the fixed monthly rental.' },
      { question: 'I’m currently using ADSL business broadband. How to I upgrade to FTTC or FTTP?', answer: 'Using our business broadband checker you can place your order to migrate your existing service over to us and benefit from quicker speeds. If you’d prefer to discuss your options with a member of our team, call us on: 0344 326 2154.' },
      { question: 'Why Business broadband over Home broadband?', answer: `As broadband is key to any modern-day business here are a few of the benefits of why you should choose Business broadband over Home broadband: - Business broadband has no data caps, is not throttled back or has network level restrictions like many Home broadband providers - Our business broadband network is for ‘businesses’, which means it’s not congested with home-user social media, streaming or gaming traffic - Up-time is key. Business broadband service level guarantees are significantly more comprehensive that Home broadband SLAs. Meaning business broadband users will be up and running much sooner should there be a fault - Dedicated support. All our business customers are allocated a dedicated account manager. In addition as we only deal with business broadband customers our support desk is less busy and are technicians less stressed. - Static IP address. All business broadband connections are provided with a static IP address, unlike many home broadband providers who offer a dynamic IP. - You get what you pay for. It’s tempting to use the free broadband provided by your home TV or phone line provider. However it’s generally a fools errand as the issues caused by highly congested home broadband and poor customer service, costs you and your business more time and money in the long run.` },
      { question: 'I work from home, can I get Business broadband?', answer: 'Business broadband can typically be provided in 99% of locations that home broadband is provided. The benefits and security of business broadband is provided from the exchange through to the internet.' },
      { question: 'What is SoGEA Business Broadband?', answer: 'SoGEA stands for Single Order Generic Ethernet Access. Until 2020 all business broadband connections had to be delivered over a traditional analogue phone line. With SoGEA there are no requirements for a analogue line, the service is delivered as a dedicated line.' },
      { question: 'With SoGEA business broadband can I use Analogue devices?', answer: 'No. If you order a SoGEA connection you will need to use an IP service e.g. VoIP phone, in order to utilise the business broadband connection.' },
      { question: 'What are the new SoGEA business broadband products that are replacing traditional broadband?', answer: 'The Single Order business broadband services which are replacing traditional broadband are:\n- FTTP\n- SOGFAST\n- SOGEA\n- SOTAP' },
      { question: 'Why is SoGEA Business broadband replacing traditional Business broadband orders?', answer: 'Previously you were required to have a single PSTN line to order your business broadband upon. BT Openreach moving forward are delivering Fibre Broadband and G Fast Fibre on a single order. This means there is no need for to have a single business line or order a business line separately.' },
      { question: 'Why SoGEA Business broadband now?', answer: 'As part of the BT Openreach PSTN & ISDN switch off in 2025 all businesses will be required to have a SoGEA business broadband connection. Therefore, it makes sense to order SoGEA now and avoid the expense later.' },
      { question: 'Can I still order traditional Business broadband before 2025?', answer: 'All traditional single line and Business broadband orders will no longer be able to be ordered from 2023.' },
      { question: 'Commercial comparison of SoGEA Business broadband?', answer: 'As SoGEA is combined Business broadband and business line rental the cost is slightly lower than a traditional business PSTN line with standard Business broadband.' },
      { question: 'Response Time & Support of SoGEA?', answer: 'With a SoGEA connection you can expect a much more responsive resolution time as you’ve got a single solution with a single business broadband provider.' },
      { question: 'Order process for SoGEA Business broadband?', answer: 'With SoGEA Business broadband you have a simplified ordering process = no single line. This means no more simultaneous line and business broadband orders or dual fault journeys.' },
      { question: 'Upgrading from ADSL Business broadband to SoGEA Business broadband?', answer: 'If you are upgrading from ADSL to SoGEA it will be upgraded with us at zero cost for new and existing customers.' },
      { question: 'Availability of SoGEA Business broadband?', answer: 'SoGEA Business broadband is currently available at over 28 million UK premises as of 2020.' },
      { question: 'Is there a data cap or a restriction on IP allocation for SoGEA Business broadband?', answer: 'SoGEA Business broadband connections are fully un-metered unless otherwise advised and are provided with a range of IP options.' },
      { question: 'What speeds can be expected from SoGEA Business broadband?', answer: 'Current speeds available to order are:\n- SoGEA Business broadband 40mb download / 10mb upload / Available to >28 Million\n- SoGEA Business broadband 55mb download / 10mb upload/ Available to >28 Million\n- SoGEA Business broadband 80mb download / 20mb upload/ Available to >28 Million\n- SoGFast Business broadband 160mb download / 30mb upload/ Available to >2 Million\n- SoGFAST Business broadband 330mb download / 50mb upload/ Available to >2 Million' },
      { question: 'What are the lead times for ordering a SoGEA Business broadband connection?', answer: 'New SoGEA Business broadband connection is 5 working days\nMigrating a SoGEA Business broadband connection is 10 working days\nModifying a SoGEA Business broadband connection is 1 working days' },
      { question: 'What is the SoGEA Business broadband Infrastructure?', answer: 'SOGEA Business broadband uses the same technology as current FTTC Business broadband products. Fibre technology is used from the local Exchange to the PCP (green street cabinet) and then copper from the PCP to the premises.' },
      { question: 'Care levels that support SoGEA Business broadband?', answer: 'Care levels allow you to place the importance on the service ‘fix time’ depending on your needs. At present only the standard care level is available however enhanced/premium options will be available later.' },
    ],
    selectedFaq: 0,
  }),
}
</script>
